export default __webpack_public_path__ + "static/media/shapeGame.5cf74e25.png";